export default (originalString) => originalString.replace(/(<([^>]+)>)/gi, '');
